<template>
  <div v-if="cda.emailPro">
    <section-title id="employees">{{
      $t("team-page-head-agency-title")
    }}</section-title>
    <div class="row">
      <div class="col-xs-12 col-md-6 col-lg-4">
        <b-card class="shadow mt-3">
          <div class="text-center">
            <!-- http://localhost:62499/photosInternes/-->
            <b-img
              :src="imgSrc + cda.pk + '.jpg'"
              width="128"
              height="128"
              class="rounded-circle mb-3"
              alt="Mélanie"
              @error.prevent.once="loadAvatar(cda, $event)"
            />
            <h3 class="h4 mb-1">{{ cda.fullName }}</h3>
            <p class="text-muted mb-1">
              {{ $t("team-page-head-agency-branch-manager") }}
            </p>
            <p class="mb-0">
              <a :href="'mailto:' + cda.emailPro">{{ cda.emailPro }}</a>
            </p>
          </div>
        </b-card>
        <b-card
          v-if="isLoading && !cda.emailPro"
          class="mb-3 shadow text-center"
        >
          <b-media>
            <spinner height="128" width="128"></spinner>
          </b-media>
        </b-card>

        <b-card class="mb-3" v-if="!cda.emailPro && !isLoading && !error">
          <b-media>-</b-media>
        </b-card>

        <b-card class="mb-3" v-if="error">
          <b-media v-html="$t('team-page-head-agency-data-error')"> </b-media>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import fallbackToAvatar from "../../Mixins/fallbackToAvatar.js";
import Spinner from "../../Helpers/Spinner/Spinner.vue";
import vitacenterImgSrc from "../../Mixins/VitacenterImgSrc.js";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    SectionTitle,
    Spinner
  },
  mixins: [fallbackToAvatar, vitacenterImgSrc],
  data() {
    return {
      cda: {},
      error: false
    };
  },
  created() {
    this.load();
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("agency", ["agencyData", "agencyError"]),
    ...mapGetters(["isLoading"])
  },
  watch: {
    agencyData(newData) {
      this.cda = newData.responsable;
    },
    agencyError() {
      this.error = true;
    }
  },
  methods: {
    ...mapActions("auth", ["handleAxiosErrors"]),
    ...mapActions("agency", ["loadAgences"]),
    load() {
      if (this.agencyData) {
        this.cda = this.agencyData.responsable;
      } else {
        this.loadAgences();
      }
    }
  }
};
</script>
